import { Injectable } from '@angular/core';

import { cleanseDownloadFilename } from './file-download.utils';

@Injectable({ providedIn: 'root' })
export class FileDownloadService {
  downloadFile(data: Blob, fileName: string, fileType?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    const newBlob = new Blob([data], { type: fileType });
    const url = window.URL.createObjectURL(newBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = cleanseDownloadFilename(fileName);
    link.click();

    // Revoke the object URL to release memory
    window.URL.revokeObjectURL(url);
  }

  createZipFileName(originalFileName: string): string {
    const splitOriginalFileName: string[] = originalFileName.split(".")
    splitOriginalFileName.pop();
    splitOriginalFileName.push("zip");
    return splitOriginalFileName.join(".");
  }
}
